// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { RevenuePlanMessageType, RevenueCommissionType } from '@shared/utils/Enums/Constants';
import { DirectMessageBaseClass } from '@shared/utils/DirectMessages/DirectMessageBase';
export class RevenuePlanMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_COMMISSION_PLAN_MESSAGE);
        this.RevenuePlanMessageType = RevenuePlanMessageType.Comission;
        this.TransferCommisionType = RevenueCommissionType.None;
        this.WithdrawalCommisionType = RevenueCommissionType.None;
        this.CommissionItems = [];
        this.SpreadItems = [];
    }
}
// #region RevenueSpreadItem
export class RevenueSpreadItem {
    get TypeId() {
        return this.InstrumentTypeId;
    }
}
// #endregion RevenueSpreadItem
